import _classCallCheck from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import AES from "crypto-js/aes";
import CryptoJSCore from "crypto-js/core";
import Base64 from "crypto-js/enc-base64";
import Utf8 from "crypto-js/enc-utf8";
import Pkcs7 from "crypto-js/pad-pkcs7";
import Rp from "sha.js";

var EncryptionUtils =
/*#__PURE__*/
function () {
  function EncryptionUtils() {
    _classCallCheck(this, EncryptionUtils);

    _defineProperty(this, "Encryptionkey", "aGgRTenEUgoACtcOAr");

    _defineProperty(this, "Decryptionkey", "AecECroRUgnGTa");

    _defineProperty(this, "hashstring", "");

    _defineProperty(this, "hashsubstring", "");

    _defineProperty(this, "Encrypted", "");

    _defineProperty(this, "Dencrypted", "");

    _defineProperty(this, "iv", Utf8.parse("globalaesvectors"));
  }

  _createClass(EncryptionUtils, [{
    key: "encryption",
    value: function encryption(e, t) {
      this.hashstring = Rp("sha256").update(this.Encryptionkey).digest("hex");
      this.hashsubstring = this.hashstring.substring(0, 32);
      var n = Utf8.parse(this.hashsubstring);

      if (e === "Encrypt") {
        var l = AES.encrypt(Utf8.parse(t), n, {
          keySize: 16,
          iv: this.iv,
          mode: CryptoJSCore.mode.CBC,
          padding: Pkcs7
        });
        return l.ciphertext.toString(Base64).split("+").join("-").split("/").join("_");
      }

      var i = t.split("-").join("+").split("_").join("/");
      return AES.decrypt(i, n, {
        keySize: 16,
        iv: this.iv,
        mode: CryptoJSCore.mode.CBC,
        padding: Pkcs7
      }).toString(Utf8);
    }
  }, {
    key: "encrypt",
    value: function encrypt(payload) {
      return this.encryption("Encrypt", payload);
    }
  }, {
    key: "decrypt",
    value: function decrypt(payload) {
      return this.encryption("Decrypt", payload);
    }
  }]);

  return EncryptionUtils;
}();

export { EncryptionUtils as default };